/* eslint-disable import/prefer-default-export */
import {
  AcceptInvitationRequest,
  BaseRequest,
  ConfirmInvitationRequest,
  CreateInvitationRequest,
  DeactivateUserRequest,
  DeactivateUserResponse,
  DeleteInvitationRequest,
  GetDeactivatedUsersRequest,
  GetDeactivatedUsersResponse,
  GetInvitedUsersForLogisticsPartyRequest,
  GetUsersForLogisticsPartyRequest,
  InvitationStatus,
  InvitedUserList,
  ResendInvitationRequest,
  User,
  UserList,
} from '@amzn/coral_com-amazon-passportusermanagementservice';
import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  ACCEPT_INVITATION_FAILURE,
  ACCEPT_INVITATION_REQUEST,
  ACCEPT_INVITATION_SUCCESS,
  CONFIRM_INVITATION_FAILURE,
  CONFIRM_INVITATION_REQUEST,
  CONFIRM_INVITATION_SUCCESS,
  CREATE_INVITATION_FAILURE,
  CREATE_INVITATION_REQUEST,
  CREATE_INVITATION_SUCCESS,
  CREATE_INVITATION_SUCCESS_RESET,
  DEACTIVATE_USER_FAILURE,
  DEACTIVATE_USER_REQUEST,
  DEACTIVATE_USER_SUCCESS,
  DELETE_INVITATION_FAILURE,
  DELETE_INVITATION_REQUEST,
  DELETE_INVITATION_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  GET_DEACTIVATED_USERS_FAILURE,
  GET_DEACTIVATED_USERS_REQUEST,
  GET_DEACTIVATED_USERS_SUCCESS,
  GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE,
  GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST,
  GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS,
  GET_USERS_FOR_LOGISTICS_PARTY_FAILURE,
  GET_USERS_FOR_LOGISTICS_PARTY_REQUEST,
  GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS,
  GET_USER_PROFILE_INFO_ACTIONS_FAILURE,
  GET_USER_PROFILE_INFO_ACTIONS_REQUEST,
  GET_USER_PROFILE_INFO_ACTIONS_SUCCESS,
  RESEND_INVITATION_FAILURE,
  RESEND_INVITATION_REQUEST,
  RESEND_INVITATION_SUCCESS,
  UPDATE_USER_LOCALE_FAILURE,
  UPDATE_USER_LOCALE_REQUEST,
  UPDATE_USER_LOCALE_SUCCESS,
  UPDATE_USER_PROFILE_INFO_FAILURE,
  UPDATE_USER_PROFILE_INFO_REQUEST,
  UPDATE_USER_PROFILE_INFO_SUCCESS,
} from './actionTypes';

export const getUserProfileInfo = createAsyncAction(
  GET_USER_PROFILE_INFO_ACTIONS_REQUEST,
  GET_USER_PROFILE_INFO_ACTIONS_SUCCESS,
  GET_USER_PROFILE_INFO_ACTIONS_FAILURE
)<BaseRequest, User, string>();

export const updateUserProfileInfo = createAsyncAction(
  UPDATE_USER_PROFILE_INFO_REQUEST,
  UPDATE_USER_PROFILE_INFO_SUCCESS,
  UPDATE_USER_PROFILE_INFO_FAILURE
)<User, User, string>();

export const updateUserLocaleAction = createAsyncAction(
  UPDATE_USER_LOCALE_REQUEST,
  UPDATE_USER_LOCALE_SUCCESS,
  UPDATE_USER_LOCALE_FAILURE
)<User, User, string>();

export const acceptInvitation = createAsyncAction(
  ACCEPT_INVITATION_REQUEST,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAILURE
)<AcceptInvitationRequest, InvitationStatus, string>();

export const createInvitation = createAsyncAction(
  CREATE_INVITATION_REQUEST,
  CREATE_INVITATION_SUCCESS,
  CREATE_INVITATION_FAILURE
)<CreateInvitationRequest, string, string>();

export const resendInvitation = createAsyncAction(
  RESEND_INVITATION_REQUEST,
  RESEND_INVITATION_SUCCESS,
  RESEND_INVITATION_FAILURE
)<ResendInvitationRequest, InvitationStatus, string>();

export const confirmInvitation = createAsyncAction(
  CONFIRM_INVITATION_REQUEST,
  CONFIRM_INVITATION_SUCCESS,
  CONFIRM_INVITATION_FAILURE
)<ConfirmInvitationRequest, InvitationStatus, string>();

export const deleteInvitation = createAsyncAction(
  DELETE_INVITATION_REQUEST,
  DELETE_INVITATION_SUCCESS,
  DELETE_INVITATION_FAILURE
)<DeleteInvitationRequest, InvitationStatus, string>();

export const getUsersForLogisticsParty = createAsyncAction(
  GET_USERS_FOR_LOGISTICS_PARTY_REQUEST,
  GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS,
  GET_USERS_FOR_LOGISTICS_PARTY_FAILURE
)<GetUsersForLogisticsPartyRequest, UserList, string>();

export const getInvitedUsersForLogisticsParty = createAsyncAction(
  GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST,
  GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS,
  GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE
)<GetInvitedUsersForLogisticsPartyRequest, InvitedUserList, string>();

export const createInvitationSuccessReset = createAction(
  CREATE_INVITATION_SUCCESS_RESET
)();

export const deactivateUser = createAsyncAction(
  DEACTIVATE_USER_REQUEST,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAILURE
)<DeactivateUserRequest, DeactivateUserResponse, string>();

export const getDeactivatedUsers = createAsyncAction(
  GET_DEACTIVATED_USERS_REQUEST,
  GET_DEACTIVATED_USERS_SUCCESS,
  GET_DEACTIVATED_USERS_FAILURE
)<GetDeactivatedUsersRequest, GetDeactivatedUsersResponse, string>();

export const fetchUserDetailsAction = createAsyncAction(
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE
)<
  { requestedUserId: string },
  { requestedUserDetails: User; requestedUserId: string },
  { requestedUserId: string }
>();

export default {
  getUserProfileInfo,
  updateUserProfileInfo,
};
